/**
 * Utility functions for tracking the most recently used craftspace
 */

const RECENT_WORKSPACE_KEY = "recent_craftspace_id";

/**
 * Store the most recently used craftspace ID
 */
export const setRecentCraftspace = (craftspaceId: string): void => {
  try {
    localStorage.setItem(RECENT_WORKSPACE_KEY, craftspaceId);
  } catch (error) {
    console.warn("Failed to store recent craftspace:", error);
  }
};

/**
 * Get the most recently used craftspace ID
 */
export const getRecentCraftspace = (): string | null => {
  try {
    return localStorage.getItem(RECENT_WORKSPACE_KEY);
  } catch (error) {
    console.warn("Failed to retrieve recent craftspace:", error);
    return null;
  }
};

/**
 * Clear the recent craftspace tracking
 */
export const clearRecentCraftspace = (): void => {
  try {
    localStorage.removeItem(RECENT_WORKSPACE_KEY);
  } catch (error) {
    console.warn("Failed to clear recent craftspace:", error);
  }
};

/**
 * Get the most recently used craftspace from a list of available craftspaces
 * Falls back to the first craftspace if no recent craftspace is found or if it doesn't exist
 */
export const getMostRecentCraftspace = (craftspaces: Array<{ id: string }>): string | null => {
  if (craftspaces.length === 0) {
    return null;
  }

  const recentCraftspaceId = getRecentCraftspace();

  // If we have a recent craftspace and it exists in the current list, use it
  if (recentCraftspaceId && craftspaces.some((w) => w.id === recentCraftspaceId)) {
    return recentCraftspaceId;
  }

  // Otherwise, fall back to the first craftspace
  return craftspaces[0].id;
};
